import useAuthUserStore from '@/modules/auth/stores/useAuthUserStore';
import Error404 from '@/modules/core/routes/error-404';
import getQueryClient from '@/modules/query-client/functions/getQueryClient';
import { routeTree } from '@/modules/router/constants/routeTree.gen';
import { createRouter } from '@tanstack/react-router';
import { pick } from 'lodash-es';

// Create a new router instance
const tanstackQueryClient = getQueryClient();

const router = createRouter({
  routeTree,
  context: {
    queryClient: tanstackQueryClient,
    userState: pick(useAuthUserStore.getState(), ['status', 'user']),
  },
  defaultPreload: 'intent',
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
  defaultNotFoundComponent: Error404,
});

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export default router;
